"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _LogoMark = require("./LogoMark");

var _LogoText = require("./LogoText");

var _designLanguage = require("@doordash/design-language");

var _constants = require("./constants");

var _styles = require("./styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _utilities = require("@doordash/utilities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Logo = function Logo(_ref) {
  var text = _ref.text,
      textColor = _ref.textColor,
      size = _ref.size,
      color = _ref.color,
      brand = _ref.brand,
      type = _ref.type;
  var renderedBrand = _constants.LogoBrands.DoorDash;

  var theme = _react["default"].useContext(_designLanguage.ThemingContext);

  if (typeof brand === 'undefined') {
    renderedBrand = (0, _lodash["default"])(theme, 'Logo.Brand', _constants.LogoBrands.DoorDash);
  } else {
    renderedBrand = brand;
  }

  var renderedColor;

  if (color === _constants.LogoColors.Default) {
    renderedColor = _constants.DefaultColors[renderedBrand];
  } else {
    renderedColor = color;
  }

  var renderedSize = _constants.DefaultLogoSizes[renderedBrand][size];

  switch (renderedBrand) {
    case _constants.LogoBrands.Caviar:
      return /*#__PURE__*/_react["default"].createElement(_styles.Root, {
        size: renderedSize
      }, type === _constants.LogoTypes.Logo ? /*#__PURE__*/_react["default"].createElement(_styles.LogoTextContainer, {
        leftSpacer: 0
      }, /*#__PURE__*/_react["default"].createElement(_LogoText.CaviarLogoText, {
        size: renderedSize,
        color: renderedColor
      })) : /*#__PURE__*/_react["default"].createElement(_LogoMark.CaviarLogoMark, {
        size: renderedSize,
        color: renderedColor
      }), text && /*#__PURE__*/_react["default"].createElement(_styles.Type, {
        size: (0, _constants.textHeightForSize)(renderedSize, _constants.LogoBrands.Caviar),
        leftSpacer: (0, _constants.spacerForSize)(renderedSize),
        color: textColor || _constants.TextColorMap[renderedColor]
      }, text));

    case _constants.LogoBrands.DoorDash:
    default:
      return /*#__PURE__*/_react["default"].createElement(_styles.Root, {
        size: renderedSize
      }, /*#__PURE__*/_react["default"].createElement(_LogoMark.DoorDashLogoMark, {
        size: renderedSize,
        color: renderedColor
      }), type === _constants.LogoTypes.Logo && /*#__PURE__*/_react["default"].createElement(_styles.LogoTextContainer, {
        leftSpacer: (0, _constants.spacerForSize)(renderedSize)
      }, /*#__PURE__*/_react["default"].createElement(_LogoText.DoorDashLogoText, {
        size: renderedSize,
        color: renderedColor
      })), text && /*#__PURE__*/_react["default"].createElement(_styles.Type, {
        size: (0, _constants.textHeightForSize)(renderedSize, _constants.LogoBrands.DoorDash),
        leftSpacer: (0, _constants.spacerForSize)(renderedSize),
        color: textColor || _constants.TextColorMap[renderedColor]
      }, text));
  }
};

Logo.propTypes = {
  type: _propTypes["default"].oneOf(Object.values(_constants.LogoTypes)),
  size: _propTypes["default"].oneOf(Object.values(_constants.LogoSizes)),
  color: _propTypes["default"].oneOf((0, _utilities.getAllPropCasesForColors)(Object.values(_constants.LogoColors))),
  text: _propTypes["default"].string,
  textColor: _propTypes["default"].oneOf((0, _utilities.getAllPropCasesForColors)(Object.values(_designLanguage.Colors))),
  brand: _propTypes["default"].oneOf(Object.values(_constants.LogoBrands))
};
Logo.defaultProps = {
  size: _constants.LogoSizes.Base,
  color: _constants.LogoColors.Default,
  textColor: _designLanguage.Colors.TextPrimary,
  type: _constants.LogoTypes.Logo
};
Logo.Colors = _constants.LogoColors;
Logo.Sizes = _constants.LogoSizes;
Logo.Brands = _constants.LogoBrands;
Logo.Types = _constants.LogoTypes;
var _default = Logo;
exports["default"] = _default;